import { HeaderCell, type HeaderCellProps as HeaderCellProps } from './HeaderCell';
import type { TableColumn } from './types';
import * as styles from './Table.css';

export interface HeadProps<TRow> {
    columns: TableColumn<TRow>[];
    sortColumn?: string;
    sortDirection?: -1 | 1;
    hasMenu?: boolean;
    hasDetails?: boolean;
    onClickHeader?: HeaderCellProps<TRow>['onClick'];
}

export function Head<TRow>({
    columns,
    sortColumn,
    sortDirection = 1,
    hasMenu = false,
    hasDetails = false,
    onClickHeader
}: HeadProps<TRow>) {
    return (
        <thead>
            <tr>
                {hasDetails && <th className={styles.chevron} />}
                {columns.map((column) => (
                    <HeaderCell
                        key={column.key ?? column.field}
                        column={column}
                        sort={sortColumn === column.field ? sortDirection : 0}
                        onClick={onClickHeader}
                    />
                ))}
                {hasMenu && <th className={styles.menu} />}
            </tr>
        </thead>
    );
}
